export default __webpack_public_path__ + "static/media/@arianystuchi.1def2f28.jpg";